


import React, { useEffect, useState } from 'react';
import { api } from '../services/api';
import { Loader2, CheckCircle, AlertCircle, PhoneIncoming } from 'lucide-react';

interface ContactRequestViewProps {
  token: string;
}

export const ContactRequestView = ({ token }: ContactRequestViewProps) => {
  const [status, setStatus] = useState<'loading' | 'success' | 'error'>('loading');
  const [errorMsg, setErrorMsg] = useState('Link Expired or Invalid');

  useEffect(() => {
    let mounted = true;

    const execute = async () => {
       if (!token) {
           setStatus('error');
           return;
       }

       try {
          // Trigger Action securely via RPC using the token
          await api.requestContact(token);
          
          if (mounted) {
             setStatus('success');
             
             // Auto Close after 2.5 seconds
             setTimeout(() => {
                window.close();
                // Fallback if window.close() is blocked
                window.location.href = "about:blank"; 
             }, 2500);
          }
       } catch (e: any) {
          console.error("Trigger error:", e);
          if (mounted) {
              setErrorMsg(e.message || 'Failed to connect');
              setStatus('error');
          }
       }
    };
    
    execute();
    return () => { mounted = false; };
  }, [token]);

  return (
    <div className="fixed inset-0 z-[9999] bg-zinc-950 flex flex-col items-center justify-center text-center p-6 animate-fade-in select-none">
       {status === 'loading' && (
          <div className="flex flex-col items-center gap-6">
             <div className="relative">
                <div className="absolute inset-0 bg-blue-500/20 blur-xl rounded-full"></div>
                <Loader2 className="animate-spin text-blue-500 relative z-10" size={64} />
             </div>
             <h2 className="text-2xl font-bold text-white tracking-tight">Connecting to Lab...</h2>
          </div>
       )}
       
       {status === 'success' && (
          <div className="flex flex-col items-center gap-6 animate-slide-up">
             <div className="w-24 h-24 bg-green-500/10 rounded-full flex items-center justify-center border border-green-500/20 shadow-[0_0_30px_rgba(34,197,94,0.3)]">
                <CheckCircle className="text-green-500" size={48} />
             </div>
             <div>
                <h2 className="text-3xl font-bold text-white mb-2">Request Sent</h2>
                <p className="text-zinc-400 text-lg">We will call you shortly.</p>
             </div>
             <div className="mt-8 h-1 w-32 bg-zinc-800 rounded-full overflow-hidden">
                <div className="h-full bg-zinc-600 animate-[width_2.5s_linear_forwards] w-0"></div>
             </div>
          </div>
       )}

       {status === 'error' && (
          <div className="flex flex-col items-center gap-4">
             <AlertCircle className="text-red-500" size={48} />
             <h2 className="text-xl font-bold text-white">{errorMsg}</h2>
             <p className="text-zinc-500">Please contact us via WhatsApp directly.</p>
          </div>
       )}
    </div>
  );
};
